import { useState, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { deleteSkill, selectSkillsStatus } from 'slices/skillsSlice'
import { ENABLE_DIALOG_ERROR_STATUS_CODES } from 'slices/utils'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  skillId: number
  onSuccess: () => void
  onCancel: () => void
}

const SkillDelete = ({ isOpen, skillId, onSuccess, onCancel }: Props) => {
  const [modalErrorMessage, setModalErrorMessage] = useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = useState(false)
  const dispatch = useDispatch()
  const { isRequesting, errorMessage } = useSelector(selectSkillsStatus, shallowEqual)

  const handleDeleteClick = () => {
    setSubmitted(true)
    dispatch(deleteSkill(skillId))
  }

  useEffect(() => {
    if (!submitted || isRequesting) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else if (!ENABLE_DIALOG_ERROR_STATUS_CODES.includes(errorMessage)) {
      setModalErrorMessage('削除できませんでした。')
    }
    setSubmitted(false)
  }, [submitted, errorMessage, isRequesting, onSuccess, dispatch])

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    onCancel()
  }

  return (
    <CustomModal
      isOpen={isOpen}
      title="スキルの削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">このスキルを本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default SkillDelete
